/* unplugin-vue-components disabled */import script from "./OpenConfigurator.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenConfigurator.vue?vue&type=script&lang=ts&setup=true"

import "./OpenConfigurator.vue?vue&type=style&index=0&id=0d688bf1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d688bf1"]])

export default __exports__